import React from 'react';
import styled from 'styled-components';

function Button({ button, title }) {
    return (
        <>
            <div className="skil">
                <h3 style={{ fontSize: 20,marginBottom:"20px" }}>{title}</h3>
                <ButtonStyled>
                    {
                        button.map((but, i) => {
                            return <>

                                <img src={but} alt="" />
                                <p id="popup">{"html"}</p>

                            </>


                        })
                    }


                </ButtonStyled>
            </div>
        </>
    )
}

const ButtonStyled = styled.div`

    border: none;
    display:flex;
    flex-wrap:wrap;
    padding: 0.1rem 1rem;
    font-size: inherit;
    justify-content: center;
    align-items: center;
    color: var(--white-color);
    
    border-radius:10px;
    @media screen and (max-width: 700px){
        border:none;
    }
  
    & img{

        @media screen and (max-width: 700px){
            max-width:40%;
        }
        max-width:18%;
        border-radius:17px;

        margin: 1rem;
   
    padding: .4rem 1rem;
    font-size: inherit;
    color: var(--white-color);
    cursor: pointer;
    transition: all .4s ease-in-out;
    margin-bottom: .6rem;
    &:active ,&:focus{
        background-color: white;
        #popup{
            display:visible;
        }
    }
    &:hover{
        background-color: white;
        #popup{
            display:flex;
        }
    }
    
    &:not(:last-child){
        margin-right: .6rem;
    }
    }

    #popup{
        position:relative;
        left:-140px;
        top:40px;

        background:red;
        display:none;
    }
    `;



const ButtonsStyled = styled.div`
    
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 2.4rem auto;
    
`;
export default Button;
